import { MHTTPCL, JSON_STRING, postJSONasFormData, createHttpGetOptions } from "../../../../services/http/http-client";
import { DISTRIBUTION_URL, LABEL_URL, JSONAPI_URL, MODIFICATION_URL, FILE_URL, CONTACTS_URL } from "../../../../services/common-urls";
import { LabelsCatalogData } from "../../store/types";


export const releaseService = {
    notice_on_change_release_date: (release_id) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "notice_on_change_release_date",
        release_id: release_id
    }),
    update_product_date_afterchange_release_date: (release_id) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "update_product_date_afterchange_release_date",
        release_id: release_id
    }),
    releasesInit: () => MHTTPCL.post(LABEL_URL, {
        section: 'releases',
        action: 'init'
    }),

    getReleases: (start) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "get_releases",
        start: start
    }),

    costGeneralData: () => MHTTPCL.post(LABEL_URL, {
        section: "common",
        action: "cost_general_data"
    }),
    multiCurrencyCostManagement: () => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "multi_currency_cost_management"
    }),

    getCommonCostGenerelData: () => MHTTPCL.post(LABEL_URL, {
        section: 'common',
        action: 'cost_general_data'
    }),

    getMultiCurrencyCostManagment: () => MHTTPCL.post(LABEL_URL, {
        section: 'releases',
        action: 'multi_currency_cost_management'
    }),

    releaseDetailsTabProducts: (release_id) => MHTTPCL.get(LABEL_URL, {
        section: 'releases',
        action: 'release_details_tab_products',
        release_id: release_id

    }),
    costTab: (external_id) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "cost_tab",
        external_table: 'release',
        external_id: external_id
    }),
    otherIncomeTab: (external_id) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "cost_tab",
        external_table: 'release_income',
        external_id: external_id
    }).then(res => {
        return {
            ...res,
            data: {
                other_incomes: res.data.costs,
                release_other_incomes_total: res.data.release_costs_total,
                product_other_incomes_total: res.data.product_costs_total,
            }
        };
    }),
    filterReleases: (str) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "filter_releases",
        str: str
    }),



    addNewReleases: ({ release_artist, release_title, label_id, identifier, release_date, label_status_id }) => MHTTPCL.post(LABEL_URL, {
        section: 'releases',
        action: 'new_release',
        release_artist: release_artist,
        release_title: release_title,
        label_id: label_id,
        identifier: identifier,
        release_date: release_date,
        label_status_id: label_status_id
    }),

    getReleasesDetails: (release_id) => MHTTPCL.get(LABEL_URL, {
        section: 'releases',
        action: 'release_details',
        release_id: release_id

    }),

    getReleaseInfo: (release_id) => MHTTPCL.post(LABEL_URL, {
        section: 'releases',
        action: 'release_info',
        release_id: release_id

    }),



    getLinks: (external_id) => MHTTPCL.post(JSONAPI_URL, {
        action: 'get_links',
        external_table: "release",
        external_id: external_id
    }),

    releaseMatchedAccounts: (release_id) => MHTTPCL.post(LABEL_URL, {
        section: 'releases',
        action: 'release_matched_accounts',
        release_id: release_id
    }),


    releaseDetailsTabOverview: (release_id) => MHTTPCL.post(LABEL_URL, {
        section: 'releases',
        action: 'release_details_tab_overview',
        release_id: release_id,
        output: JSON_STRING
    }),

    modifyRelease: (key, kVal, name, value, table) => MHTTPCL.post(MODIFICATION_URL, {
        key: key,
        kVal: kVal,
        name: name,
        value: value,
        table: table,


    }),

    releaseDetailsTabText: (release_id) => MHTTPCL.get(LABEL_URL, {
        section: 'releases',
        action: 'release_details_tab_text',
        release_id: release_id
    }),

    getunrelatedGenres: (release_id) => MHTTPCL.get(LABEL_URL, {
        section: 'releases',
        action: 'unrelated_genres',
        release_id: release_id

    }),

    searchUnrelatedGenres: (release_id, search) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "search_unrelated_genres",
        release_id: release_id,
        search: search,
        output: JSON_STRING
    }),


    addReleaseGenre: (release_id, genre_id) => MHTTPCL.get(LABEL_URL, {
        section: 'releases',
        action: 'add_release_genre',
        release_id: release_id,
        genre_id: genre_id
    }),


    releaseNewGenre: (release_id, genre_name) => MHTTPCL.get(LABEL_URL, {
        section: 'releases',
        action: 'release_new_genre',
        release_id: release_id,
        genre_name: genre_name

    }),

    addRemoveGenre: (external_id, genre_id, genre_relation_id) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "add_remove_genre",
        external_id: external_id,
        genre_id: genre_id,
        external_table: "release",
        genre_relation_id: genre_relation_id
    }),

    releaseTemplateModal: (release_id) => MHTTPCL.get(LABEL_URL, {
        section: 'releases',
        action: 'release_template_modal',
        release_id: release_id

    }),

    addLink: (link_type, link_description, link, external_id) => MHTTPCL.post(JSONAPI_URL, {
        action: "add_link",
        link_type: link_type,
        link_description: link_description,
        link: link,
        external_table: "release",
        external_id: external_id
    }),
    deleteLink: (link_id) => MHTTPCL.post(JSONAPI_URL, {
        action: "delete_link",
        link_id: link_id
    }),

    releaseAccountRelationForm: (release_id) => MHTTPCL.get(LABEL_URL, {
        section: "releases",
        action: "release_account_relation_form",
        release_id: release_id
    }),

    addReleaseAccountRelation: (release_id, account_id, text02) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "add_release_account_relation",
        release_id: release_id,
        account_id: account_id,
        text02: text02
    }),

    removeReleaseAccountRelation: (relation_id) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "remove_release_account_relation",
        relation_id: relation_id
    }),

    unrelatedArtists: (release_id) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "unrelated_artists",
        release_id: release_id
    }),

    searchUnrelatedArtists: (release_id, search) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "search_unrelated_artists",
        release_id: release_id,
        search: search
    }),

    addSelectedArtists: (release_id, artists) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "add_selected_artists",
        release_id: release_id,
        artists: artists
    }),


    deleteReleaseArtist: (relation_id) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "delete_release_artist",
        relation_id: relation_id
    }),

    deleteDocumentRelation: (file_id, file_relation_id) => MHTTPCL.post(FILE_URL, {

        action: "delete_document_relation",
        file_id: file_id,
        file_relation_id: file_relation_id

    }),
    filterCosts: (external_id, str, cost_groups) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "filter_costs",
        external_table: "release",
        external_id: external_id,
        str: str,
        cost_groups: cost_groups
    }),

    updateCostHoldflag: (cost_split_id, hold_flag) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "update_cost_holdflag",
        cost_split_id: cost_split_id,
        hold_flag: hold_flag

    }),
    deleteCost: (cost_split_id) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "delete_cost",
        cost_split_id: cost_split_id
    }),

    releaseDetailsTabSales: (release_id) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "release_details_tab_sales",
        release_id: release_id

    }),

    deleteContactRelation: (contact_relation_id) => MHTTPCL.post(CONTACTS_URL, {
        action: "delete_relation",
        contact_relation_id: contact_relation_id
    }),


    addRelatedProductForm: (release_id) => MHTTPCL.get(LABEL_URL, {
        section: "releases",
        action: "add_related_product_form",
        release_id: release_id
    }),

    newRelatedReleaseProduct: (catalog_no, format_id, related_product_id, release_id, barcode,alt_title,alt_artist,product_date) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "new_related_release_product",
        catalog_no: catalog_no,
        barcode: barcode,
        format_id: format_id,
        related_product_id: related_product_id,
        alt_artist:alt_artist,
        alt_title:alt_title,
        release_id: release_id,
        product_date:product_date
    }),
    loadReleaseRelatedProducts: (release_id) => MHTTPCL.get(LABEL_URL, {
        section: "releases",
        action: "load_release_related_products",
        release_id: release_id
    }),

    advanceReleaseSearch: (action, payload, start = 0, row_count = 100) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: action,
        start: start,
        row_count: row_count,
        data: JSON.stringify(payload),
        output: JSON_STRING
    }),

    releaseAdvancedSearchModalData: () => MHTTPCL.post(LABEL_URL, {
        section: `releases`,
        action: `release_advance_search_modal`,
        output: JSON_STRING
    }),

    releaseReportModal: () => MHTTPCL.get(DISTRIBUTION_URL, {
        section: "reports",
        action: "release_report_modal",
        output: JSON_STRING
    }),
    filterReleaseReport: ({ label_id, start_date, end_date }) => MHTTPCL.postJSONasFormData(DISTRIBUTION_URL, {
        label_id: label_id,
        start_date: start_date,
        end_date: end_date,
        section: "reports",
        action: "filter_release_report",
        output: JSON_STRING
    }, createHttpGetOptions({
        responseType: 'blob'
    })),

    removeRelease: (release_id) => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "remove_release",
        release_id: release_id
    }),

    createReleaseInitModal: () => MHTTPCL.post(LABEL_URL, {
        section: "releases",
        action: "create_release",
        output: JSON_STRING
    })







    //    "{\"label_id\":\"\",\"artist\":\"\",\"title\":\"\",\"release_type\":\"\",\"release_status\":\"\",\"identifier\":\"\",\"start_date\":\"\",\"end_date\":\"\",\"offset\":0,\"row_count\":100}"







}